// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCdTpdlS5TC9-o1XMJ7epMZaoNUWNvoTME",
  authDomain: "book-bingo-9b992.firebaseapp.com",
  projectId: "book-bingo-9b992",
  storageBucket: "book-bingo-9b992.firebasestorage.app",
  messagingSenderId: "704108137234",
  appId: "1:704108137234:web:457077035fe56ca5f1c1cb",
  measurementId: "G-H2JFD1MEHB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);
// Initialize Performance Monitoring and get a reference to the service
const performance = getPerformance(app);
export { auth, firestore, storage, performance };
